var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2.4C0.5 1.76348 0.763392 1.15303 1.23223 0.702944C1.70107 0.252856 2.33696 1.66215e-08 3 1.66215e-08H12.375C12.9814 -6.84576e-05 13.5671 0.211431 14.0231 0.595113C14.4791 0.978795 14.7743 1.50851 14.8538 2.0856L18.7413 0.4272C18.9315 0.345806 19.14 0.311356 19.3477 0.326983C19.5554 0.342609 19.7557 0.407815 19.9304 0.516675C20.1052 0.625535 20.2488 0.774595 20.3483 0.950309C20.4478 1.12602 20.4999 1.32281 20.5 1.5228V10.4772C20.4998 10.677 20.4477 10.8737 20.3483 11.0492C20.2488 11.2248 20.1053 11.3738 19.9308 11.4826C19.7562 11.5914 19.5561 11.6567 19.3486 11.6724C19.141 11.6882 18.9327 11.6539 18.7425 11.5728L14.8538 9.9144C14.7743 10.4915 14.4791 11.0212 14.0231 11.4049C13.5671 11.7886 12.9814 12.0001 12.375 12H3C2.33696 12 1.70107 11.7471 1.23223 11.2971C0.763392 10.847 0.5 10.2365 0.5 9.6V2.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.625d46f5ca7def6a5926589ff20f8492.svg";
export { ForwardRef as ReactComponent };